import {Injectable} from '@angular/core';

interface OrderConfig {
    param: string;
    group: any[];
    altParam?: string;
}

@Injectable()
export class OrderByService {
    sortBy: string = '';
    currentSortDirection: string = 'asc';
    currentSortParam: string = '';
    sortBy1: string = '';
    currentSortDirection1: string = 'asc';
    currentSortParam1: string = '';

    resetService() {
        this.sortBy = '';
        this.currentSortDirection = 'asc';
        this.currentSortParam = '';
        this.sortBy1 = '';
        this.currentSortDirection1 = 'asc';
        this.currentSortParam1 = '';
    }

    orderByParam(param, group, altParam?) {
        const presort = group;
        let final = [...presort];
//console.log(final);
        if(
            param === 'commentTime' ||
            param === 'RequestNo' ||
            param === 'companyID' || 
            param === 'product' || 
            param === 'subject' || 
            param === 'status' || 
            //param === 'requestDate' || 
            param === 'assignedTo' ||             
            //param === 'tdate' || 
            param === 'face' ||
            param === 'cost' ||
            param === 'marketValue' ||
            param === 'marketPrice' ||
            param === 'purchPrice' ||
            param === 'fxRate' ||
            param === 'quantity' ||
            param === 'settlementAmount' ||
            param === 'price' ||
            param === 'debit' ||
            param === 'credit' ||
            param === 'balance' ||
            //param === 'date'||
            param === 'daysAccrued' || 
            param === 'uploadTime' 
            || param === 'fileName' || 
            param === 'uploadedBy' ||
            param === 'commentBy' ||
            param === 'comments' 
            || param === 'statusAfter'
             || param === 'edate'
        ){
            var dateOrNum = true;
        } else {
            var dateOrNum = false;
        };
       // console.log('dateOrNum '+ dateOrNum);

        if(param === this.currentSortParam && this.currentSortDirection === 'asc') {
            final = this.orderByParamDescending(param, presort, altParam);
            this.currentSortDirection = 'desc';
            this.sortBy = `${param}down`;
            //console.log(final);
        } else {
            final = this.orderByParamAscending(param, presort, altParam);
            this.currentSortDirection = 'asc';
            this.sortBy = `${param}up`;
            //console.log(final);
        }
        this.currentSortParam = param;
        return final;
    }

    //order ascending- start with lowest
    orderByParamAscending(param, group, altParam?)  {
        //console.log(param, group, altParam);
        return group.sort((a, b): any => {
            //account for possible null values - set to empty str if so
            if((!a[param] && typeof a[param] !== 'boolean' && a[param] !== 0)) {
                a[param] = '';
            }
            if((!b[param] && typeof b[param] !== 'boolean' && b[param] !== 0)) {
                b[param] = '';
            }

            let first = a[param], second = b[param];
            let altFirst, altSecond;

            if(altParam) {
                altFirst = a[altParam];
                altSecond = b[altParam];

                if(altParam.indexOf('date') !== -1 || altParam.indexOf('time') !== -1) {
                    altFirst = +new Date(a[altParam]);
                    altSecond = +new Date(b[altParam]);
                } else if(typeof a[altParam] === 'string') {
                    altFirst = a[altParam].toLowerCase();
                    altSecond = b[altParam].toLowerCase();
                }
            }

            if(param.indexOf('date') !== -1 || param.indexOf('time') !== -1) {
                first = +new Date(a[param]);
                second = +new Date(b[param]);
            } else if(a[param] == +a[param]) {
                first = +a[param];
                second = +b[param];
            } else if(typeof a[param] === 'string') {
                first = a[param].toLowerCase();
                second = b[param].toLowerCase();
            }

            if(first < second) {
                return -1;
            } else if(second < first) {
                return 1;
            } else {
                if(altParam) {
                    if(altFirst < altSecond) {
                        return -1;
                    } else if(altSecond < altFirst) {
                        return 1;
                    }
                    return 0;
                }
                return 0;
            }
        });
    }

    //order descending- start with greatest
    orderByParamDescending(param, group, altParam?)  {
        //console.log(param, group, altParam);
        return group.sort((a, b): number => {
            //account for possible null values - set to empty str if so
            if((!a[param] && typeof a[param] !== 'boolean' && a[param] !== 0)) {
                a[param] = '';
            }
            if((!b[param] && typeof b[param] !== 'boolean' && b[param] !== 0)) {
                b[param] = '';
            }

            let first = a[param], second = b[param];
            let altFirst, altSecond;

            //altParam provides fallback sorting- need to make same checks for date/str as normal param
            if(altParam) {
                altFirst = a[altParam];
                altSecond = b[altParam];

                if(altParam.indexOf('date') !== -1 || altParam.indexOf('time') !== -1) {
                    altFirst = +new Date(a[altParam]);
                    altSecond = +new Date(b[altParam]);
                } else if(typeof a[altParam] === 'string') {
                    altFirst = a[altParam].toLowerCase();
                    altSecond = b[altParam].toLowerCase();
                }
            }

            //properly format sort data (date/string here)
            if(param.indexOf('date') !== -1 || param.indexOf('time') !== -1) {
                first = +new Date(a[param]);
                second = +new Date(b[param]);
            } else if(a[param] == +a[param]) {
                first = +a[param];
                second = +b[param];
            } else if(typeof a[param] === 'string') {
                first = a[param].toLowerCase();
                second = b[param].toLowerCase();
            }

            if(first < second) {
                return 1;
            } else if(second < first) {
                return -1;
            } else {
                if(altParam) {
                    if(altFirst < altSecond) {
                        return -1;
                    } else if(altSecond < altFirst) {
                        return 1;
                    }
                    return 0;
                }
                return 0;
            }
        });
    }
    orderByParam1(param, group, altParam?) {
        const presort = group;
        let final = [...presort];

        if(
            param === 'RequestNo' ||
            param === 'companyID' || 
            param === 'product' || 
            param === 'subject' || 
            param === 'status' || 
            param === 'requestDate' || 
            param === 'assignedTo' ||             
            param === 'tdate' || 
            param === 'face' ||
            param === 'cost' ||
            param === 'marketValue' ||
            param === 'marketPrice' ||
            param === 'purchPrice' ||
            param === 'fxRate' ||
            param === 'quantity' ||
            param === 'settlementAmount' ||
            param === 'price' ||
            param === 'debit' ||
            param === 'credit' ||
            param === 'balance' ||
            param === 'date'||
            param === 'daysAccrued' ||
            param === 'maturitydate' || param === 'priority'
        ){
            var dateOrNum = true;
        } else {
            var dateOrNum = false;
        };
        //console.log('dateOrNum '+ dateOrNum);

        if(param === this.currentSortParam1 && this.currentSortDirection1 === 'asc') {
            final = this.orderByParamDescending1(param, presort, altParam);
            this.currentSortDirection1 = 'desc';
            this.sortBy1 = `${param}down`;
        } else {
            final = this.orderByParamAscending1(param, presort, altParam);
            this.currentSortDirection1 = 'asc';
            this.sortBy1 = `${param}up`;
        }
        this.currentSortParam1 = param;
        return final;
    }

    //order ascending- start with lowest
    orderByParamAscending1(param, group, altParam?)  {
        return group.sort((a, b): any => {
            //account for possible null values - set to empty str if so
            if((!a[param] && typeof a[param] !== 'boolean' && a[param] !== 0)) {
                a[param] = '';
            }
            if((!b[param] && typeof b[param] !== 'boolean' && b[param] !== 0)) {
                b[param] = '';
            }

            let first = a[param], second = b[param];
            let altFirst, altSecond;

            if(altParam) {
                altFirst = a[altParam];
                altSecond = b[altParam];

                if(altParam.indexOf('date') !== -1 || altParam.indexOf('time') !== -1) {
                    altFirst = +new Date(a[altParam]);
                    altSecond = +new Date(b[altParam]);
                } else if(typeof a[altParam] === 'string') {
                    altFirst = a[altParam].toLowerCase();
                    altSecond = b[altParam].toLowerCase();
                }
            }

            if(param.indexOf('date') !== -1 || param.indexOf('time') !== -1) {
                first = +new Date(a[param]);
                second = +new Date(b[param]);
            } else if(a[param] == +a[param]) {
                first = +a[param];
                second = +b[param];
            } else if(typeof a[param] === 'string') {
                first = a[param].toLowerCase();
                second = b[param].toLowerCase();
            }

            if(first < second) {
                return -1;
            } else if(second < first) {
                return 1;
            } else {
                if(altParam) {
                    if(altFirst < altSecond) {
                        return -1;
                    } else if(altSecond < altFirst) {
                        return 1;
                    }
                    return 0;
                }
                return 0;
            }
        });
    }

    //order descending- start with greatest
    orderByParamDescending1(param, group, altParam?)  {
        return group.sort((a, b): number => {
            //account for possible null values - set to empty str if so
            if((!a[param] && typeof a[param] !== 'boolean' && a[param] !== 0)) {
                a[param] = '';
            }
            if((!b[param] && typeof b[param] !== 'boolean' && b[param] !== 0)) {
                b[param] = '';
            }

            let first = a[param], second = b[param];
            let altFirst, altSecond;

            //altParam provides fallback sorting- need to make same checks for date/str as normal param
            if(altParam) {
                altFirst = a[altParam];
                altSecond = b[altParam];

                if(altParam.indexOf('date') !== -1 || altParam.indexOf('time') !== -1) {
                    altFirst = +new Date(a[altParam]);
                    altSecond = +new Date(b[altParam]);
                } else if(typeof a[altParam] === 'string') {
                    altFirst = a[altParam].toLowerCase();
                    altSecond = b[altParam].toLowerCase();
                }
            }

            //properly format sort data (date/string here)
            if(param.indexOf('date') !== -1 || param.indexOf('time') !== -1) {
                first = +new Date(a[param]);
                second = +new Date(b[param]);
            } else if(a[param] == +a[param]) {
                first = +a[param];
                second = +b[param];
            } else if(typeof a[param] === 'string') {
                first = a[param].toLowerCase();
                second = b[param].toLowerCase();
            }

            if(first < second) {
                return 1;
            } else if(second < first) {
                return -1;
            } else {
                if(altParam) {
                    if(altFirst < altSecond) {
                        return -1;
                    } else if(altSecond < altFirst) {
                        return 1;
                    }
                    return 0;
                }
                return 0;
            }
        });
    }
}